"use client";
import { Hero } from "app/components/hero";
import { HeroButtons } from "app/components/views/home/heroButtons";
import {
  EVE_NG_CONSTANTS,
  EVE_NG_HOSTED_BACKED_SERVICES_LIST,
  EVE_NG_FAQ,
} from "./components/constants";
import banner from "public/eve-ng/banner.svg";
import { SectionDivider } from "app/components/shared/SectionDivider";
import ListLayout from "app/components/shared/listLayout";
import CloudHostedOptions from "./cloudHostedCards";
import EveNgPricingTypes from "./components/pricingTypes";
import EveNgPricing from "./evengPricing";
import EveNgCompareTable from "./evengTable";
import Certificates from "app/components/views/home/Certificates";
import CustomCarousel from "app/components/shared/CustomCarousel";
import TalkToUs from "app/components/shared/talkToUs";
import WhyEveNg from "./components/whyEveNg";
import CustomAccordionList from "../gns3/components/customaccordion";

const EveNgPage = () => {
  return (
    <>
      <Hero
        title={"EVE-NG Cloud Hosted Platform"}
        description={EVE_NG_CONSTANTS.HERO_DESC}
        image={banner}
        imageAlt={"Three professionals discussing over a topic with a system in front."}
        premiumPartner
      >
        <HeroButtons />
      </Hero>
      <WhyEveNg />
      <SectionDivider label={"Our Hosted services are Backed By"} />
      <ListLayout data={EVE_NG_HOSTED_BACKED_SERVICES_LIST} />
      <CloudHostedOptions />
      <Certificates />
      <EveNgPricingTypes />
      <EveNgPricing />
      <EveNgCompareTable />
      <CustomAccordionList items={EVE_NG_FAQ} />
      <CustomCarousel />
      <TalkToUs />
    </>
  );
};

export default EveNgPage;
